import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  thumbnail: string;
  duration: string;
  views: number;
  publishDate: string;
  author: string;
  authorAvatar: string;
  categoryName: string;
  categorySlug: string;
  quality: string;
  slug: string;
}

function formatViews(views: number): string {
  if (views >= 10000) {
    return (views / 10000).toFixed(1) + '万';
  }
  return views.toString();
}

export default function VideoCard({
  id,
  title,
  thumbnail,
  duration,
  views,
  publishDate,
  author,
  authorAvatar,
  categoryName,
  categorySlug,
  quality,
  slug,
}: VideoCardProps) {
  return (
    <article className="group cursor-pointer">
      <Link to={`/video/${id}`} className="block">
        {/* Thumbnail */}
        <div className="relative overflow-hidden rounded-lg aspect-video mb-3">
          <img
            src={thumbnail}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            title={`${title} - 91视频网`}
          />
          {/* Hover overlay */}
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 scale-75 group-hover:scale-100">
              <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
            </div>
          </div>
          {/* Duration */}
          <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-black/75 text-background-50 text-xs font-medium">
            {duration}
          </span>
          {/* Quality */}
          <span className="absolute top-2 left-2 px-1.5 py-0.5 rounded bg-primary-500/90 text-background-50 text-xs font-medium">
            {quality}
          </span>
        </div>

        {/* Info */}
        <div className="flex gap-3">
          {/* Author Avatar */}
          <Link
            to={`/category/${categorySlug}`}
            className="flex-shrink-0 mt-0.5"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-9 h-9 rounded-full overflow-hidden bg-background-200">
              <img
                src={authorAvatar}
                alt={author}
                className="w-full h-full object-cover"
                title={author}
              />
            </div>
          </Link>

          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-medium text-foreground-950 line-clamp-2 leading-snug mb-1 group-hover:text-primary-600 transition-colors">
              {title}
            </h3>
            <p className="text-xs text-foreground-500 mb-1">{author}</p>
            <div className="flex items-center gap-2 text-xs text-foreground-400 flex-wrap">
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {formatViews(views)}
              </span>
              <span>·</span>
              <span>{publishDate}</span>
              <span>·</span>
              <Link
                to={`/category/${categorySlug}`}
                className="text-secondary-600 hover:text-secondary-700 transition-colors"
                onClick={(e) => e.stopPropagation()}
              >
                {categoryName}
              </Link>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
}